module.exports = __webpack_public_path__ + "static/media/funnel_effect_en.a5a5710e.png";